import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SettingsTaxesForm from 'components/hiboutikForms/SettingsTaxesForm'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class EditTaxesHiboutikModal extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    auth: PropTypes.object.isRequired,
    refreshTaxes: PropTypes.func.isRequired
  }
  state = { okDisabled: true }
  componentDidMount() {}
  handleHiboutikFormClick = () => {
    this.setState({ okDisabled: false })
  }
  render() {
    const { title, auth } = this.props
    return (
      <ModalWrapper
        open
        maxWidth={'xs'}
        onOk={this.props.refreshTaxes}
        title={title}
        cancelText="Fermer"
        okText="Mettre à jour"
        showOk
        okDisabled={this.state.okDisabled}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              Vous devez mofifier ce paramètre sur Hiboutik, cliquez sur le
              boutton suivant :
            </Typography>
            <SettingsTaxesForm
              onClick={this.handleHiboutikFormClick}
              hiboutikAccount={auth.hiboutikAccount}
            />
            <Typography variant="caption" gutterBottom>
              « Une fois les modifications effectuées et enregistrées sur
              Hiboutik, cliquez sur 'METTRE A JOUR' »
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(EditTaxesHiboutikModal)



// WEBPACK FOOTER //
// ./src/components/modals/admin/EditTaxesHiboutikModal.js